import * as Yup from "yup";
const nipRegExp = /(^\d{8,}$|^$)/;

export const getFormSchema = (t) => {
	return Yup.object().shape({
		name: Yup.string()
			.required(t("fill_required_fields"))
			.min(2, t("name_has_to_be_at_least_two_characters_long")),
		email: Yup.string()
			.required(t("fill_required_fields"))
			.email(t("invalid_email_format")),
		nip: Yup.string()
			.nullable()
			.notRequired()
			.matches(nipRegExp, t("invalid_nip_format")),
	});
};
